import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { id: "NavigationBar" }
const _hoisted_2 = { class: "NavigationContainer" }
const _hoisted_3 = ["title", "onClick"]
const _hoisted_4 = { class: "NavText" }
const _hoisted_5 = ["title", "href"]
const _hoisted_6 = { class: "NavText" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.internalNavItems, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            class: _normalizeClass([
						'NavigationItem',
						'InternalNavigationItem',
						{ 'ActionRequired': _ctx.doesPageRequireAction(item.path) },
						{ 'IsActive': _ctx.isPathActive(item.path) },
						{ 'NavigationItemDisabled': item.disabled }
					]),
            title: item.disabled ? item.disabledLabel : item.label,
            onClick: ($event: any) => (_ctx.navigateToPage(item.path, item.disabled))
          }, [
            _createElementVNode("i", {
              class: _normalizeClass([
						'NavIcon',
						item.icon
					])
            }, null, 2 /* CLASS */),
            _createCommentVNode(" Since we don't have a way to show icons as bold, duplicate the icon so that the lines appear thicker. "),
            _createElementVNode("i", {
              class: _normalizeClass([
						'NavIcon',
						'SecondNavIcon',
						item.icon
					])
            }, null, 2 /* CLASS */),
            _createElementVNode("span", _hoisted_4, _toDisplayString(item.label), 1 /* TEXT */)
          ], 10 /* CLASS, PROPS */, _hoisted_3))
        }), 256 /* UNKEYED_FRAGMENT */))
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "NavigationGroupTitle" }, " Quick Access ", -1 /* CACHED */)),
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.externalNavItems, (item) => {
          return (_openBlock(), _createElementBlock("li", null, [
            _createElementVNode("a", {
              class: _normalizeClass([
							'NavigationItem',
							{ 'NavigationItemDisabled': item.disabled }
						]),
              title: item.disabled ? item.disabledLabel : item.label,
              href: item.path
            }, [
              _createElementVNode("i", {
                class: _normalizeClass([
							'NavIcon',
							item.icon
						])
              }, null, 2 /* CLASS */),
              _createCommentVNode(" Since we don't have a way to show icons as bold, duplicate the icon so that the lines appear thicker. "),
              _createElementVNode("i", {
                class: _normalizeClass([
							'NavIcon',
							'SecondNavIcon',
							item.icon
						])
              }, null, 2 /* CLASS */),
              _createElementVNode("span", _hoisted_6, _toDisplayString(item.label), 1 /* TEXT */)
            ], 10 /* CLASS, PROPS */, _hoisted_5)
          ]))
        }), 256 /* UNKEYED_FRAGMENT */))
      ])
    ])
  ]))
}